import { WidgetCustomManagedStreamConfig } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { HistPriceVolStreamManager } from 'widgets/historicalPercentageChange/store/data/HistPriceVolStreamManager.ts';

export const histPriceVolStreamConfig: WidgetCustomManagedStreamConfig = {
    channelDestination: 'startHistPriceVolStream',
    managerFactory: (options) => new HistPriceVolStreamManager(options),
};
